import {LoaderCircle} from 'lucide-react';
import './loader.scss';

export const Loader = () => <LoaderCircle className="loader"/>;